import { styled } from 'linaria/react';
import React, { FC, PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import { Desktop, useIsClient } from '@shared/lib/react';
import { useCarousel } from '@shared/lib/hooks/useCarousel';
interface CarouselProps {
  leftButton?: ReactNode;
  rightButton?: ReactNode;
  alwaysShowScrollButtons?: boolean;
}
const Carousel: FC<PropsWithChildren<CarouselProps>> = ({
  leftButton,
  rightButton,
  alwaysShowScrollButtons = false,
  children
}) => {
  const [isContentLargerThanContainer, setIsContentLargerThanContainer] = useState<boolean>(false);
  const {
    ref,
    atStart,
    atEnd,
    scrollForward,
    scrollBack
  } = useCarousel();
  const isClient = useIsClient();
  useEffect(() => {
    const containerWidth = ref.current?.getBoundingClientRect().width || 0;
    const contentWidth = ref.current?.firstElementChild?.getBoundingClientRect().width || 0;
    setIsContentLargerThanContainer(containerWidth < contentWidth);
  }, []);
  return <CarouselWrapper alwaysShowScrollButtons={alwaysShowScrollButtons}>
      {!atStart && isClient && isContentLargerThanContainer && <Desktop>
          <ScrollBackButtonWrapper onClick={scrollBack} className="carousel-scroll-button">
            {leftButton}
          </ScrollBackButtonWrapper>
        </Desktop>}
      <CarouselContentWrapper ref={ref}>{children}</CarouselContentWrapper>
      {!atEnd && isClient && isContentLargerThanContainer && <Desktop>
          <ScrollForwardButtonWrapper onClick={scrollForward} className="carousel-scroll-button">
            {rightButton}
          </ScrollForwardButtonWrapper>
        </Desktop>}
    </CarouselWrapper>;
};
export default Carousel;
const _exp = /*#__PURE__*/() => ({
  alwaysShowScrollButtons
}) => alwaysShowScrollButtons ? 'flex' : 'none';
const CarouselWrapper = /*#__PURE__*/styled('div')({
  name: "CarouselWrapper",
  class: "c1f1l8vs",
  propsAsIs: false,
  vars: {
    "c1f1l8vs-0": [_exp()]
  }
});
const CarouselContentWrapper = /*#__PURE__*/styled('div')({
  name: "CarouselContentWrapper",
  class: "cezlk06",
  propsAsIs: false
});
const ScrollBackButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollBackButtonWrapper",
  class: "sxt399w",
  propsAsIs: false
});
const ScrollForwardButtonWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollForwardButtonWrapper",
  class: "s1ar6dfh",
  propsAsIs: false
});

require("./Carousel.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./Carousel.tsx");